import clsx from 'clsx';
import React from 'react';

import { TiModalColorScheme } from '@components/TIModal';

const PlanDetail = ({ term, theme, definition }) => (
  <div className="mt-8">
    <dt
      className={clsx('inline font-suisse-intl-mono', {
        'text-grayscale-beige': theme === TiModalColorScheme.dark,
        'text-grayscale-gray': theme === TiModalColorScheme.light,
      })}
    >
      {term}:{' '}
    </dt>
    <dd
      className={clsx('m-0 inline font-suisse-intl', {
        'text-white': theme === TiModalColorScheme.dark,
        'text-black': theme === TiModalColorScheme.light,
      })}
    >
      {definition}
    </dd>
  </div>
);

export default PlanDetail;
